"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Separator = void 0;
var SeparatorPrimitive = _interopRequireWildcard(require("@radix-ui/react-separator"));
var _cn = require("@udecode/cn");
var _classVarianceAuthority = require("class-variance-authority");
var separatorVariants = (0, _classVarianceAuthority.cva)('shrink-0 bg-border', {
  defaultVariants: {
    orientation: 'horizontal'
  },
  variants: {
    orientation: {
      horizontal: 'h-px w-full',
      vertical: 'h-full w-px'
    }
  }
});
var Separator = exports.Separator = (0, _cn.withVariants)((0, _cn.withProps)(SeparatorPrimitive.Root, {
  decorative: true,
  orientation: 'horizontal'
}), separatorVariants);